@let isBdnBased = vesselSpecStore.vesselSpec()?.bdn_based_reporting;

@if (!isBdnBased) {
  <re-fuel-specs-non-bdn></re-fuel-specs-non-bdn>
}
